<div class="card harp-reg-card harp-material">
  <div class="card-body">
    <h2 class="profile-info harp-card-title">Profile Information</h2>

    <div *ngIf="!hasProofError">
      <span class="visually-hidden"
        >Buttons on this page open modal dialogs. It may be necessary to
        initiate reading with the read continuously command for your screen
        reader.</span
      >
      <!-- Pre Populate By Experian Reference Number Button -->
      <p>
        Enter your profile information for identity proofing. HARP uses Experian
        to help verify your identity. Already called Experian?
        <button class="link" (click)="openFarsModal()">
          Enter a Reference Number</button
        >.
      </p>

      <!-- Retry Failed RIDP Button -->
      <p>
        Want to retry a previously failed registration attempt?
        <button
          class="link retry-proofing"
          (click)="resetProfileInfoForm(); openModal(retryProofing)"
        >
          Retry Remote Identity Proofing</button
        >.
      </p>

      <p>
        All fields marked with an asterisk (<span class="required">*</span>) are
        required.
      </p>
    </div>

    <!-- Error Message -->
    <div class="row" *ngIf="experianProofingService.errorMessage?.length">
      <div class="col-12">
        <div
          class="alert alert-danger"
          role="alert"
          [innerHTML]="experianProofingService.errorMessage"
        >
          {{ experianProofingService.errorMessage }}
        </div>
      </div>
    </div>

    <!-- Uniqueness Error Message -->
    <div class="row" *ngIf="saviyntService.errorMessage?.length">
      <div class="col-12">
        <div id="profInfoUnqErrorMsg" class="alert alert-danger" role="alert">
          {{ saviyntService.errorMessage }}
        </div>
      </div>
    </div>

    <form [formGroup]="profileInfoForm" *ngIf="!hasProofError">
      <div class="row">
        <!-- First Name -->
        <div class="col">
          <harp-input
            [inputConfig]="firstNameInputConfig"
            [maskData]="true"
          ></harp-input>
        </div>

        <!-- Last Name -->
        <div class="col">
          <harp-input
            [inputConfig]="lastNameInputConfig"
            [maskData]="true"
          ></harp-input>
        </div>
      </div>

      <div class="row">
        <!-- Middle Name -->
        <div class="col">
          <harp-input
            [inputConfig]="middleNameInputConfig"
            [maskData]="true"
          ></harp-input>
        </div>

        <!-- Date of Birth -->
        <div class="col">
          <harp-input
            [inputConfig]="dateOfBirthInputConfig"
            [maskData]="true"
          ></harp-input>
        </div>
      </div>

      <div class="row">
        <!-- Personal Email Address -->
        <div class="col">
          <harp-input
            [inputConfig]="personalEmailAddressInputConfig"
            [maskData]="true"
          ></harp-input>
        </div>

        <!-- Confirm Personal Email Address -->
        <div class="col">
          <harp-input
            [inputConfig]="confirmPersonalEmailAddressInputConfig"
            [maskData]="true"
          ></harp-input>
        </div>
      </div>

      <div class="row">
        <!-- Secondary Email Address -->
        <div class="col">
          <harp-input
            [inputConfig]="businessEmailAddressInputConfig"
            [maskData]="true"
          ></harp-input>
        </div>

        <!-- Confirm Email Address -->
        <div class="col">
          <harp-input
            [inputConfig]="confirmBusinessEmailAddressInputConfig"
            [maskData]="true"
          ></harp-input>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <!-- Business Phone Number -->
          <harp-input
            *ngIf="isUSAddress"
            [inputConfig]="personalPhoneNumberInputConfig"
            [maskData]="true"
          ></harp-input>

          <!-- Foreign Phone Number -->
          <harp-input
            *ngIf="!isUSAddress"
            [inputConfig]="foreignPhoneNumberInputConfig"
            [maskData]="true"
          ></harp-input>
        </div>

        <div class="col">
          <harp-input
            *ngIf="isUSAddress"
            [inputConfig]="businessPhoneNumberInputConfig"
            [maskData]="true"
          ></harp-input>
        </div>
      </div>

      <div class="row">
        <!-- Is US Address -->
        <div class="col">
          <harp-input
            [inputConfig]="isUSAddressInputConfig"
            [maskData]="true"
          ></harp-input>
        </div>
      </div>

      <div class="row" *ngIf="isUSAddress">
        <!-- Address Line 1 -->
        <div class="col">
          <harp-input
            [inputConfig]="addressLine1InputConfig"
            [maskData]="true"
          ></harp-input>
        </div>

        <!-- Address Line 2 -->
        <div class="col">
          <harp-input
            [inputConfig]="addressLine2InputConfig"
            [maskData]="true"
          ></harp-input>
        </div>
      </div>

      <div class="row" *ngIf="!isUSAddress">
        <!-- Foreign Address Line 1 -->
        <div class="col">
          <harp-input
            [inputConfig]="foreignAddressLine1InputConfig"
            [maskData]="true"
          ></harp-input>
        </div>

        <!-- Foreign Address Line 2 -->
        <div class="col">
          <harp-input
            [inputConfig]="foreignAddressLine2InputConfig"
            [maskData]="true"
          ></harp-input>
        </div>
      </div>

      <div class="row">
        <!-- City -->
        <div class="col">
          <harp-input [inputConfig]="cityInputConfig"></harp-input>
        </div>

        <div class="col">
          <!-- State -->
          <harp-input
            *ngIf="isUSAddress"
            [inputConfig]="stateInputConfig"
            [maskData]="true"
          ></harp-input>

          <!-- Country -->
          <harp-input
            *ngIf="!isUSAddress"
            [inputConfig]="countryInputConfig"
            [maskData]="true"
          ></harp-input>
        </div>
      </div>

      <div class="row" *ngIf="isUSAddress">
        <!-- Zip Code -->
        <div class="col">
          <harp-input
            [inputConfig]="zipCodeInputConfig"
            [maskData]="true"
          ></harp-input>
        </div>

        <!-- Zip Code Extension -->
        <div class="col">
          <harp-input
            [inputConfig]="zipCodeExtensionInputConfig"
            [maskData]="true"
          ></harp-input>
        </div>
      </div>

      <div class="row">
        <!-- SSN -->
        <div class="col-6">
          <harp-input
            [inputConfig]="ssnInputConfig"
            [maskData]="true"
          ></harp-input>

          <!-- Initiate Manual Proofing Help Text-->
          <p class="harp-help-text" [hidden]="hideInitiateManualProofing">
            Don't want to enter your SSN?
            <button
              id="profInfoIniManulProf"
              type="button"
              class="link"
              (click)="openModal(manualProofing, 'lg')"
              [disabled]="!canInitiateManualProofing"
            >
              Initiate Manual Proofing
            </button>
          </p>
        </div>
      </div>

      <div *ngIf="captchaConfig$ | async as captchaConfig; else loading">
        <re-captcha
          [hidden]="!isFarsFlow || profileInfoControl.invalid"
          formControlName="captcha"
          name="captcha"
          [required]="isFarsFlow"
          theme="light"
          [siteKey]="captchaConfig.reCaptchaSiteKey"
        ></re-captcha>
      </div>
    </form>

    <!-- Terms and Conditions Button -->
    <div class="row" *ngIf="!hasProofError">
      <div class="col-12">
        <p class="mb-0 mt-2">
          By registering for HARP, you agree to the
          <button
            id="profinfoTermsConds"
            class="link"
            type="button"
            (click)="openModal(termsAndConditions, 'lg')"
          >
            Terms &amp; Conditions</button
          >.
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Initiate RIDP Proofing Button -->
<div class="row" [hidden]="!isUSAddress">
  <div class="col-md-3 offset-md-9">
    <button
      id="profInfoSaveNextBtn"
      class="btn btn-primary btn-lg d-block w-100 harp-button-margin"
      (click)="initiateExperianProofingFlow()"
      [disabled]="profileInfoForm.invalid"
      type="submit"
    >
      Next <em class="icon ion-md-arrow-round-forward"></em>
    </button>
  </div>
</div>

<!-- Initiate Manual Proofing Button -->
<div class="row" [hidden]="isUSAddress">
  <div class="col-md-5 offset-md-7">
    <button
      id="profInfoManualModalBtn"
      class="btn btn-primary btn-lg d-block w-100 harp-button-margin"
      (click)="openModal(manualProofing, 'lg')"
      [disabled]="!canInitiateManualProofing"
      type="submit"
    >
      Initiate Manual Proofing
    </button>
  </div>
</div>

<!--FARS MODULE -->
<ng-template #referenceNumber let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modalTitle">Experian Reference Number</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="d()"
    ></button>
  </div>
  <div class="modal-body">
    <app-alert [alertService]="modalAlertService"></app-alert>

    <p>
      If you have already spoken to Experian and were able to be identity
      proofed over the phone, enter your reference number and associated email
      address to continue with the registration process. This will pre-populate
      the Profile Information form with your information.
    </p>

    <form [formGroup]="farsForm">
      <!-- Reference Number Input -->
      <harp-input
        [inputConfig]="farsReferenceNumberInputConfig"
        [maskData]="true"
      ></harp-input>

      <!-- Email Input -->
      <harp-input
        [inputConfig]="farsEmailInputConfig"
        [maskData]="true"
      ></harp-input>
    </form>

    <p>
      <em class="icon ion-ios-alert"></em>&nbsp;<strong>IMPORTANT:</strong> On
      the next page, make sure to update your Profile Information with the same
      <strong>first name</strong>, <strong>last name</strong>, and
      <strong>SSN</strong> verified by Experian.
    </p>
  </div>
  <div class="modal-footer">
    <button
      id="experianModalCancelBtn"
      type="button"
      class="btn btn-outline-primary"
      (click)="c()"
    >
      Cancel
    </button>
    <button
      id="experianModalSubmitBtn"
      type="button"
      [disabled]="farsForm.invalid"
      class="btn btn-primary"
      (click)="initiateFARSFlow(FARSInformationForm)"
    >
      Submit
    </button>
  </div>
</ng-template>

<!-- INITIATE MANUAL PROOFING -->
<form class="save-form" #ManualProofInformationForm="ngForm">
  <ng-template #manualProofing let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title" id="modalTitle">Initiate Manual Proofing</h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="d()"
      ></button>
    </div>
    <div class="modal-body">
      <div class="alert alert-danger" *ngIf="!canInitiateManualProofing">
        Please enter all required fields to submit Profile Information for
        manual proofing.
      </div>
      <app-initiate-manual-proofing></app-initiate-manual-proofing>
    </div>
    <div class="modal-footer">
      <button
        id="manualProofSubmitBtn"
        [disabled]="!canManualProof()"
        type="button"
        class="btn btn-outline-primary"
        (click)="initiateManualProofFlow(); c()"
      >
        Submit Info for Manual Proofing
      </button>
      <button
        id="manualProofCancelBtn"
        type="button"
        class="btn btn-primary"
        (click)="c()"
      >
        Cancel
      </button>
    </div>
  </ng-template>
</form>

<!-- RETRY REMOTE PROOFING -->
<ng-template #retryProofing let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modalTitle">Retry Remote Proofing</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="d()"
    ></button>
  </div>
  <div class="row" *ngIf="experianProofingService.errorMessage?.length">
    <div class="col-12">
      <div id="questionServErrorMsg" class="alert alert-danger" role="alert">
        {{ experianProofingService.errorMessage }}
      </div>
    </div>
  </div>
  <div class="modal-body">
    <app-alert [alertService]="modalAlertService"></app-alert>

    <p>
      Enter the fields below to retry remote proofing with your previous
      registration attempt. This will pre-populate the Profile Information form
      with your information.
    </p>

    <form [formGroup]="retryRIDPForm">
      <!-- User ID Input -->
      <harp-input
        [inputConfig]="retryUserIdInputConfig"
        [maskData]="true"
      ></harp-input>

      <!-- Password Input -->
      <harp-input
        [inputConfig]="retryPasswordInputConfig"
        [maskData]="true"
      ></harp-input>

      <!-- Retry RIDP Options Input -->
      <harp-input
        [inputConfig]="retryRIDPOptionsInputConfig"
        [maskData]="true"
      ></harp-input>

      <!-- SSN Input -->
      <harp-input
        *ngIf="iKnowLast4OfSSN"
        [inputConfig]="retrySSNInputConfig"
        [maskData]="true"
      ></harp-input>

      <!-- DOB Input -->
      <harp-input
        *ngIf="iKnowLast4OfSSN"
        [inputConfig]="retryDobInputConfig"
        [maskData]="true"
      ></harp-input>

      <!-- Reference Number Input -->
      <harp-input
        *ngIf="!iKnowLast4OfSSN"
        [inputConfig]="retryReferenceIdInputConfig"
        [maskData]="true"
      ></harp-input>
    </form>
  </div>

  <div class="modal-footer">
    <!-- Cancel Button -->
    <button type="button" class="btn btn-outline-primary" (click)="c()">
      Cancel
    </button>

    <!-- Submit Retry RIDP Button -->
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="retryRIDPForm.invalid"
      (click)="initiateRetryRIDP()"
    >
      Submit
    </button>
  </div>
</ng-template>

<!-- TERMS AND CONDITIONS -->
<ng-template #termsAndConditions let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modalTitle">Terms and Conditions</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="d()"
    ></button>
  </div>
  <div class="modal-body">
    <app-terms-and-conditions></app-terms-and-conditions>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="c()">Close</button>
  </div>
</ng-template>

<!-- CMS BYPASS PROOFING/REGISTRATION -->
<ng-template #cmsBypassProofingModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modalTitle">Bypass Registration</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="d()"
    ></button>
  </div>
  <div class="modal-body">
    <p>
      Based on your email address, HARP has identified you as a Centers for
      Medicare and Medicaid Services (CMS) employee. CMS employees may bypass
      HARP registration and use their EUA credentials to log into HARP.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="c()">
      Cancel
    </button>
    <a href="/login" class="btn btn-primary"
      >Log into HARP with EUA credentials</a
    >
  </div>
</ng-template>
